import { render, staticRenderFns } from "./FlowConfig.vue?vue&type=template&id=53db961e&"
import script from "./FlowConfig.vue?vue&type=script&lang=js&"
export * from "./FlowConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports